<template>
    <quill-editor
        :style="{height: height + 'px'}"
        ref="myQuillEditor"
        @blur="blur"
        :content="value"
        @change="getHTML"
        :options="editorOption"
    />
</template>

<script>
import 'quill/dist/quill.snow.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
Quill.register('modules/ImageExtend', ImageExtend)
export default {
    props: {
        value: {
            type: String,
            default: '',
        }, 
        height: {
            type: Number,
            default: 400
        }
    }, 
    components: { quillEditor },
    data() {
        return {
            content: '',
            editorOption: {
                modules: {
                    ImageExtend: {
                        loading: true,
                        name: 'img',
                        action: '',
                    },
                    toolbar: {
                        container: container,
                        handlers: {
                            'image': function () {
                                QuillWatch.emit(this.quill.id)
                            },
                        },
                    }
                }
            }
        }
    },
    methods: {
        getHTML(event) {
            this.$emit('input', event.html)
        },
        blur(){
            let el = document.querySelector('.ql-tooltip,.ql-editing')
            if(el && el.style.left.indexOf('-') === 0) el.style.left = 0
        }
    }
}
</script>

<style scoped>
.ql-tooltip .ql-editing{
    z-index: 99999;
}
</style>>